import Api from '@/api/Api'
import store from '../store'

export default {

  async getAll (params = {}) {
    return store.dispatch('checkResponseApi', await Api().get('sales', { params }))
  },

  async getSingle (data) {
    return store.dispatch('checkResponseApi', await Api().get('sale?so_id=' + data.so_id))
  },

  async insert (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('sale', data, options))
  },

  async update (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('sale', data, options))
  },

  async updateStatus (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('sale/status', data, options))
  },

  async delete (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().delete('sale', { data: data }, options))
  },

  async getLatestCode (data) {
    return store.dispatch('checkResponseApi', await Api().get('sale/latest_code'))
  },
}



// WEBPACK FOOTER //
// ./src/api/SaleService.js